module.exports = __webpack_public_path__ + "static/media/5abbb46d-1b4e-4143-b456-9d8831d2c1f0.d45f2922.JPG";